








































import { Component, Vue } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class Recharge extends Vue {
  private bankInfo = {
      'name': '',
      'acc_number': '',
      'acc_name': ''
    }
  private bankInfos = [
    {
      'name': 'MBbank',
      'acc_number': '03583790311224',
      'acc_name': 'DUONG THI THUY VAN'
    },
    {
      'name': 'MBbank',
      'acc_number': '652172',
      'acc_name': 'DUONG THI HUYEN'
    },
    // {
    //   'name': 'ACB',
    //   'acc_number': '35688886868',
    //   'acc_name': 'CONG TY TNHH HANG CHINA 247'
    // },
    // {
    //   'name': 'ACB',
    //   'acc_number': '388226868',
    //   'acc_name': 'CONG TY TNHH UNISHIP LOGISTICS'
    // }
  ]
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get qrLink() {
    return `https://api.vietqr.io/image/${this.bankInfo.name}-${this.bankInfo.acc_number}-xM1xYdA.jpg?addInfo=UN${this.userInfo.userId}&accountName=${this.bankInfo.acc_name}`;
  }
}
